import { memo, useCallback } from 'react';

import { type ShortUrlResponse } from '@air/api/types';

import { OnOffShareToggleRow } from '~/components/ShareModal/components/OnOffShareToggleRow';
import { SecurityPrivacySection } from '~/components/ShareModal/components/SecurityPrivacySection/SecurityPrivacySection';
import { useUpdateShareCanvasLink } from '~/components/SharePrivateCanvasModal/hooks/useUpdateShareCanvasLink';
import { shareUrlUpdatedLinkAccess } from '~/utils/shortUrl/shareUrlUpdatedAnalytics';

export type SharePrivateCanvasModalBodyProps = {
  canEdit: boolean;
  canvasId: string;
  shortIdInfo: ShortUrlResponse;
};

export const SharePrivateCanvasModalBody = memo(
  ({ canEdit, canvasId, shortIdInfo }: SharePrivateCanvasModalBodyProps) => {
    const { onShortUrlUpdate, isLoading } = useUpdateShareCanvasLink({ canvasId, shortIdInfo });

    const handleToggleEnablePublicLink = useCallback(
      (enabled: boolean) =>
        onShortUrlUpdate({ props: { disabled: !enabled }, analytics: shareUrlUpdatedLinkAccess(enabled) }),
      [onShortUrlUpdate],
    );

    return (
      <>
        <OnOffShareToggleRow
          label="Enable public link"
          disabled={!canEdit}
          checked={!shortIdInfo.disabled}
          isLoading={isLoading}
          onToggle={handleToggleEnablePublicLink}
        />
        <SecurityPrivacySection shortIdInfo={shortIdInfo} isLoading={isLoading} onShortUrlUpdate={onShortUrlUpdate} />
      </>
    );
  },
);

SharePrivateCanvasModalBody.displayName = 'SharePrivateCanvasModalBody';
